import React from 'react';
import { ExternalLink, Youtube } from 'lucide-react';
import type { DisplayYouTubeVideo } from '../pages/HomePage'; // Ajuste o caminho se necessário

interface YouTubeVideoCardProps {
  video: DisplayYouTubeVideo;
}

const YouTubeVideoCard: React.FC<YouTubeVideoCardProps> = ({ video }) => {
  const channelName = video.youtube_channels?.channel_name || 'Canal Desconhecido';
  // Tenta obter a URL do canal. Prioriza custom_url, depois constrói a partir de channel_id.
  const channelUrl = video.youtube_channels?.custom_url
    ? (video.youtube_channels.custom_url.startsWith('http') ? video.youtube_channels.custom_url : `https://www.youtube.com/${video.youtube_channels.custom_url}`)
    : (video.youtube_channels?.channel_id ? `https://www.youtube.com/channel/${video.youtube_channels.channel_id}` : undefined);

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300 h-full flex flex-col">
      <a
        href={video.video_url}
        target="_blank"
        rel="noopener noreferrer"
        className="block relative group"
        aria-label={`Assistir ${video.title} no YouTube`}
      >
        <img
          src={video.thumbnail_url}
          alt={`Thumbnail do vídeo ${video.title}`}
          className="w-full h-40 object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-black bg-opacity-20 group-hover:bg-opacity-10 flex items-center justify-center transition-opacity duration-300">
          <Youtube className="h-12 w-12 text-white opacity-80 group-hover:opacity-100" />
        </div>
      </a>
      <div className="p-3 flex flex-col flex-grow">
        <h3 className="text-sm font-semibold text-gray-800 dark:text-gray-100 mb-1.5 leading-tight">
          <a
            href={video.video_url}
            target="_blank"
            rel="noopener noreferrer"
            title={video.title}
            className="hover:text-indigo-600 dark:hover:text-indigo-400 line-clamp-2"
          >
            {video.title}
          </a>
        </h3>
        
        <div className="mt-auto pt-2 text-xs text-gray-500 dark:text-gray-400">
          {channelUrl ? (
            <a 
              href={channelUrl} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="flex items-center hover:text-indigo-500 dark:hover:text-indigo-400 transition-colors"
              title={`Visitar canal ${channelName}`}
            >
              {video.youtube_channels?.thumbnail_url && (
                <img 
                  src={video.youtube_channels.thumbnail_url} 
                  alt={`Logo do canal ${channelName}`} 
                  className="w-5 h-5 rounded-full mr-1.5 object-cover"
                />
              )}
              <span className="truncate">{channelName}</span>
              <ExternalLink size={12} className="ml-1 flex-shrink-0" />
            </a>
          ) : (
            <div className="flex items-center">
              {video.youtube_channels?.thumbnail_url && (
                <img 
                  src={video.youtube_channels.thumbnail_url} 
                  alt={`Logo do canal ${channelName}`} 
                  className="w-5 h-5 rounded-full mr-1.5 object-cover"
                />
              )}
              <span className="truncate">{channelName}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default YouTubeVideoCard; 